"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var notification_container_1 = require("./notification-container");

exports.notificationAddActionType = "notification/add";

function notificationAddAction(notification) {
  var _a;

  var id = getNotificationId();
  var type = (_a = notification.type) !== null && _a !== void 0 ? _a : "default";
  return {
    type: exports.notificationAddActionType,
    payload: Object.assign(Object.assign({}, notification), {
      id: id,
      type: type
    })
  };
}

exports.notificationAddAction = notificationAddAction;

function notificationAddActionMatcher(a) {
  return a.type === exports.notificationAddActionType;
}

exports.notificationAddActionMatcher = notificationAddActionMatcher;
exports.notificationUpdateActionType = "notification/update";

function notificationUpdateAction(id, notification) {
  return {
    type: exports.notificationUpdateActionType,
    payload: {
      id: id,
      notification: notification
    }
  };
}

exports.notificationUpdateAction = notificationUpdateAction;

function notificationUpdateActionMatcher(a) {
  return a.type === exports.notificationUpdateActionType;
}

exports.notificationUpdateActionMatcher = notificationUpdateActionMatcher;
exports.notificationLifecycleActionType = "notification/lifecycle";

function notificationLifecycleAction(id, lifecycle) {
  return {
    type: exports.notificationLifecycleActionType,
    payload: {
      id: id,
      lifecycle: lifecycle
    }
  };
}

exports.notificationLifecycleAction = notificationLifecycleAction;

function notificationLifecycleActionMatcher(a) {
  return a.type === exports.notificationLifecycleActionType;
}

exports.notificationLifecycleActionMatcher = notificationLifecycleActionMatcher; // Lifecycle helpers

function notificationDismissAction(id) {
  return notificationLifecycleAction(id, notification_container_1.NotificationLifecycle.OLD);
}

exports.notificationDismissAction = notificationDismissAction; // Generate a unique ID for every notification.
// These will only be unique to the current browser window

var notificationId = 0;

function getNotificationId() {
  notificationId++;
  return notificationId.toString();
}